import { observable, computed, action, makeObservable } from 'mobx';
import { WorkflowComment } from 'nomst/Stores/Decision/workflowComment';
import {
    IManagerWorkflow
} from 'typings/manager';
import { IWorkflowReviewer } from 'typings/workflow';

export class ManagerWorkflow implements IManagerWorkflow {

    @computed
    get previousReviewer(): Nullable<IWorkflowReviewer> {
        return this.previousReviewerIndex > - 1 ? this.reviewers[this.previousReviewerIndex] : null;
    }

    get managerSourceId(): string {
        return this._managerSourceId;
    }

    @observable reviewers: IWorkflowReviewer[];

    @observable currentReviewer: NullOrUndefined<IWorkflowReviewer>;

    @observable currentReviewerIndex: number;

    @observable previousReviewerIndex: number;

    @observable currentReviewerDisplayName: string;

    @observable isApproved: boolean;

    @observable approvedByUserId: string;

    @observable approvedByUserDisplayName: string;

    @observable nextReviewerDisplayName: string;

    @observable previousReviewerDisplayName: string;

    @observable workflowComments: WorkflowComment[];
    private readonly _managerSourceId: string;

    constructor(managerWorkflow: IManagerWorkflow) {
        makeObservable(this);
        this._managerSourceId = managerWorkflow.managerSourceId;
        this.reviewers = managerWorkflow.reviewers ?
            managerWorkflow.reviewers.map(reviewer =>
                ({
                    reviewerId: reviewer.reviewerId,
                    workflowReviewerType: reviewer.workflowReviewerType,
                    workflowRuleName: reviewer.workflowRuleName
                })) : [];
        this.currentReviewer = managerWorkflow.currentReviewer ?
            {
                reviewerId: managerWorkflow.currentReviewer.reviewerId,
                workflowReviewerType: managerWorkflow.currentReviewer.workflowReviewerType,
                workflowRuleName: managerWorkflow.currentReviewer.workflowRuleName
            } :
            undefined;
        this.currentReviewerDisplayName = managerWorkflow.currentReviewerDisplayName;
        this.isApproved = managerWorkflow.isApproved;
        this.approvedByUserId = managerWorkflow.approvedByUserId;
        this.approvedByUserDisplayName = managerWorkflow.approvedByUserDisplayName;
        this.nextReviewerDisplayName = managerWorkflow.nextReviewerDisplayName;
        this.previousReviewerDisplayName = managerWorkflow.previousReviewerDisplayName;
        this.workflowComments = managerWorkflow.workflowComments ?
            managerWorkflow.workflowComments.map(comment =>
                new WorkflowComment(comment)) : [];

        this.setReviewersIndex();
    }

    @action
    setReviewersIndex(): void {
        this.setCurrentReviewerIndex();
        this.setPreviousReviewerIndex();
    }

    @action
    private setCurrentReviewerIndex(): void {
        const currentReviewer = this.currentReviewer;
        if (!currentReviewer) {
            this.currentReviewerIndex = -1;
            return;
        }

        this.currentReviewerIndex = this.reviewers.findIndex(reviewer =>
            reviewer.reviewerId === currentReviewer.reviewerId &&
            reviewer.workflowReviewerType === currentReviewer.workflowReviewerType &&
            reviewer.workflowRuleName === currentReviewer.workflowRuleName);
    }

    @action
    private setPreviousReviewerIndex(): void {
        if (this.currentReviewerIndex > 0) {
            this.previousReviewerIndex = this.currentReviewerIndex - 1;
            return;
        }

        this.previousReviewerIndex = -1;
    }
}